import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as utils from "../../assets/utils";
import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class PosTh extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.tha = [];
        this.state.row = {};

        this.state.today = new Date();
        //var fdatum = startOfMonth(this.state.today);
        var fdat = format(this.state.today, "yyyy-MM-dd");
        var tdat = format(this.state.today, "yyyy-MM-dd");
        this.state.fdat = fdat;
        this.state.tdat = tdat;

        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.fdts = dts;
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.st_th();
    }

    componentWillUnmount(){
    }

    onScroll(event) {
        var body = document.getElementById("web-body");
        if (body.scrollTop > 150) {
          this.setState({top: 0})
          this.setState({info: 'small'})
        } else {
          this.setState({top: 1})
          this.setState({info: 'big:'+body.scrollTop})
        }

        if (true) {
            var offset = body.scrollTop;
            var start = body.scrollTop;
            var slut = body.scrollTop + window.innerHeight;

            for(var mnuid of this.state.mnus) {
                const element = document.getElementById(mnuid);
                if(!element || (element == null) || (element == undefined)) continue;
                var eltop = element.offsetTop;
                var elbot = element.offsetTop + element.offsetHeight;
                var brc = eltop >= start && eltop <= slut;
                //if(!brc) brc = elbot >= start && elbot <= slut;
                if(brc) {
                    this.setState({mnu_sel: mnuid});
                    return;
                }
            }
        }
    }
    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    row_style(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.anstnummer == row.anstnummer) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    row_show(row) {
        var css = {};
        css.display = "none";
        if(this.state.row) {
            if(this.state.row.anstnummer == row.anstnummer) {
                css.display = "";
            }
        }
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        return css;
    }

    st_th() {
        var self = this;
    
        var prm = {};
        prm.req = "ta.ta_th.hrs_dt";
        prm.avd = this.state.avd;
        prm.datum = this.state.dts;
        //alert(JSON.stringify(prm));
        
        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));
    
            self.setState({ tha: ret.tpa });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
      }
    
  xst_th() {
    var self = this;

    var prm = {};
    //prm.req = "ta.ta_th.act_list";
      //prm.req = "ta.ta_th.per_ft";
      prm.req = "ta.ta_th.act_dt";
    prm.avd = this.state.avd;
    prm.fdat = this.state.fdat;
      prm.tdat = this.state.tdat;
      prm.datum = this.state.dts;
    //alert(JSON.stringify(prm));

    if(this.store.seo.kid.ztrim() == "353") {
        prm.sid = "S0002269";
        net.sid_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));

            self.setState({ tha: ret.rca });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
        return;
    }

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ tha: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    row_sel(row) {
        if(this.state.row) {
            if(this.state.row.anstnummer == row.anstnummer) {
                this.setState({ row: {} });
                return;
            }
        }
        this.setState({ row: row });
        return;
    }
    row_open(row) {
        return;
    }

    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column px-3">


                <div className="d-flex flex-row justify-content-between">
                    <div className="">INLOGGADE</div>
                </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="web-link" onClick={() => this.st_th() }>UPPDATERA</div>
                </div>
                <div className="divider_orange"></div>

                <div className="flex hide">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th>Anstnr</th>
                        <th>Namn</th>
                        <th>Start</th>
                        <th>Slut</th>
                        <th>Netto</th>
                        <th>Rast</th>
                        <th>Brutto</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.tha.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.row_open(row) } >
                        <td>{ utils.toNum( row.anstnummer ) }</td>
                        <td>{ utils.toLang( row.namn ) }</td>
                        <td>{ utils.toTid( row.start ) }</td>
                        <td>{ utils.toTid( row.slut ) }</td>
                        <td>{ row.netto }</td>
                        <td>{ row.rast }</td>
                        <td>{ row.brutto }</td>
                    </tr>
                    )}
                    </tbody>
                </table>
            </div>
                <div className="flex">
                    <div className="flex-col thead">
                        <div className="flex-row">
                            <div className="">ID</div>
                            <div className="flex px-2">Namn</div>
                            <div className="w50">Start</div>
                            <div className="w50">Slut</div>
                        </div>
                    </div>
                        <div style={ this.tb_style() }>
                        { this.state.tha.map((row, key) =>
                            <div key={key} style={ this.row_style(row) } className="flex-col trow" onClick={() => this.row_sel(row) } onDoubleClick={() => this.row_open(row) }>
                                <div className="flex-row">
                                <div className="">{ utils.toNum( row.anstnummer ) }</div>
                                <div className="flex px-2">{ utils.toLang( row.namn ) }</div>
                                <div className="w50">{ utils.toTid( row.start ) }</div>
                                <div className="w50">{ utils.toTid( row.slut ) }</div>
                                </div>
                                <div className="flex-col px-2" style={ this.row_show(row) }>
                                <div>Netto:{ row.netto }</div>
                                <div className="">Rast:{ row.rast }</div>
                                <div>Brutto:{ row.brutto }</div>
                                </div>
                                </div>
                        )}
                        </div>
                </div>
                <div className="">
                <div className="txt_14">Antal : { this.state.tha.length }</div>
            </div>


         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default PosTh;
